import { Box, Button, Grid, Menu, MenuItem, Stack, TextField, Typography } from "@mui/material"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { StartUpperCase } from "../../../global/Format";

export const MenuItems = ({platform, role, form, open, anchorEl, handleClose, inputHandler, generateHandler, department, selectUser }) => {
   
    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            slotProps={{
                paper: {
                    elevation: 0,
                    sx: {
                        ml:3,
                        mt:.8,
                        borderRadius:'12px',
                        width:'349px',
                        p:'0px',
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        '&::before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 2,
                            right: 8,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        >
            <Stack p={2} gap={1.5}>
                {/* IF PERSONAL KINDLY REMOVE THE CONDITION role  */}
                <Stack gap={1}>
                    <Box display="flex" alignItems="center" gap={.5}>
                        <Typography fontSize={14} fontWeight={400} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">Interval</Typography>
                        <Typography fontSize={14} fontWeight={400} lineHeight="142%" letterSpacing="0%" color="#E34935">*</Typography>
                    </Box>
                    <TextField select name="interval" variant="outlined" fullWidth 
                        error={form.data.interval.stat} 
                        helperText={form.data.interval.msg} 
                        onChange={(e)=>inputHandler(e, '', '')}
                        value={form.data.interval.value}
                    >
                        <MenuItem value="daily" defaultValue>Daily</MenuItem>
                        <MenuItem value="weekly">Weekly</MenuItem>
                        <MenuItem value="monthly">Monthly</MenuItem>
                        <MenuItem value="quarterly">Quarterly</MenuItem>
                        <MenuItem value="yearly">Yearly</MenuItem>
                    </TextField>
                </Stack>
                <Stack gap={1}>
                    <Box display="flex" alignItems="center" gap={.5}>
                        <Typography fontSize={14} fontWeight={400} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">{StartUpperCase(form.data.interval.value)} Date</Typography>
                        <Typography fontSize={14} fontWeight={400} lineHeight="142%" letterSpacing="0%" color="#E34935">*</Typography>
                    </Box>
                    {form.data.interval.value !== 'quarterly' ? 
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker views={form.data.interval.value==='yearly'?['year']:form.data.interval.value==='monthly'?['month', 'year']:['day']} label="" value={form.data.date.value} onChange={(v)=>inputHandler({target: {name: 'date', value: v}}, '', '')}
                                renderInput={(params) => <TextField {...params} error={form.data.date.stat} helperText={form.data.date.msg} />}
                            />
                        </LocalizationProvider>
                    :
                        <Grid container spacing={1.5} direction="row" justifyContent="center" alignItems="center">
                            <Grid item xs={7}>
                                <TextField select name="quarter" value={form.data.quarter.value} variant="outlined" fullWidth error={form.data.quarter.stat} onChange={(e)=>inputHandler(e, '', '')}>
                                    <MenuItem value="1st" defaultValue>1st Quarter</MenuItem>
                                    <MenuItem value="2nd">2nd Quarter</MenuItem>
                                    <MenuItem value="3rd">3rd Quarter</MenuItem>
                                    <MenuItem value="4th">4th Quarter</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={5}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker views={['year']} label="" value={form.data.date.value} onChange={(v)=>inputHandler({target: {name: 'date', value: v}}, '', '')}
                                    renderInput={(params) => <TextField {...params} error={form.data.date.stat}  />}
                                />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                    }
                </Stack>
                <Stack gap={1}>
                    <Box display="flex" alignItems="center" gap={.5}>
                        <Typography fontSize={14} fontWeight={400} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">Sequence Order</Typography>
                        <Typography fontSize={14} fontWeight={400} lineHeight="142%" letterSpacing="0%" color="#E34935">*</Typography>
                    </Box>
                    <TextField select name="order" variant="outlined" fullWidth 
                        value={form.data.order.value} 
                        error={form.data.order.stat} 
                        helperText={form.data.order.msg} 
                        onChange={(e)=>inputHandler(e, '','')} 
                    >
                        <MenuItem value="asc" defaultValue>
                            4 Succeeding {form.data.interval.value}
                        </MenuItem>
                        <MenuItem value="desc">
                            4 Previous {form.data.interval.value}
                        </MenuItem>
                    </TextField>
                </Stack>
                <Stack gap={1.5} direction="row">
                    <Button
                        onClick={generateHandler}
                        sx={{
                            height:'44px',
                            width:'111px',
                            borderRadius:'6px',
                            bgcolor:'#003022',
                            ':hover':{bgcolor:'#003022'}
                        }}
                    >
                        <Typography fontSize={14} fontWeight={600} lineHeight="147%" letterSpacing="0%" color="#FFFFFF">Generate</Typography>
                    </Button>
                    <Button
                        onClick={handleClose}
                        sx={{
                            height:'44px',
                            width:'80px',
                            borderRadius:'6px',
                            bgcolor:'#F7F8F8',
                            ':hover':{bgcolor:'#F7F8F8'}
                        }}
                    >
                        <Typography fontSize={12} fontWeight={400} lineHeight="142%" letterSpacing="0%" color="#292C2F">Close</Typography>
                    </Button>
                </Stack>
            </Stack>
        </Menu>
    )
}